import { render, staticRenderFns } from "./rate-input.vue?vue&type=template&id=7cb048f6"
import script from "./rate-input.vue?vue&type=script&lang=js"
export * from "./rate-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports